import { DOMINANT_ELEMENT_CAREERS } from '../data/dominantElementCareers';

const getLocalizedValue = (value, language) => {
  if (!value) return value;
  if (Array.isArray(value)) return value;
  return value[language] || value.vi || value.en || value;
};

export const getCareerClustersByDominantElement = (element, language = 'vi') => {
  const data = DOMINANT_ELEMENT_CAREERS[element];
  if (!data) return [];

  return data.clusters.map((cluster) => ({
    id: cluster.id,
    title: getLocalizedValue(cluster.title, language),
    summary: getLocalizedValue(cluster.summary, language),
    tags: getLocalizedValue(cluster.tags, language) || [],
    skills_core: getLocalizedValue(cluster.skills_core, language) || [],
    roadmap_10w: getLocalizedValue(cluster.roadmap_10w, language) || [],
    roles: cluster.roles.map((role) => ({
      id: role.id,
      name: getLocalizedValue(role.name, language),
      tags: getLocalizedValue(role.tags, language) || [],
      skills_core: getLocalizedValue(role.skills_core, language) || [],
      roadmap_10w: getLocalizedValue(role.roadmap_10w, language) || []
    }))
  }));
};
